// pc console daily 筛选器
import PcConsoleDailyFilterV2 from '@/pages/dashboard/filterPageComponents/overview/PcConsoleDailyFilterV2';
//  pc console daily 卡片
import PcConsoleDailyFilterV3 from '@/pages/dashboard/filterPageComponents/overview/PcConsoleDailyFilterV3';
import DauBreakdownContext from '@/pages/dashboard/pages/overview/pcConsoleDailyV2/components/DauBreakdownContext';
import OsBreakDownContext from '@/pages/dashboard/pages/overview/pcConsoleDailyV2/components/OsBreakDownContext';
import CountriesContextTab from '@/pages/dashboard/pages/overview/pcConsoleDailyV2/components/CountriesContextTab';
import DauCountriesContext from '@/pages/dashboard/pages/overview/pcConsoleDailyV2/components/DauCountriesContext';
import NewCountriesContext from '@/pages/dashboard/pages/overview/pcConsoleDailyV2/components/NewCountriesContext';
import PcConsoleOverviewV2Table from '@/pages/dashboard/pages/overview/pcConsoleDailyV2/components/PcConsoleOverviewV2Table';
import UserCompositionCo from '@/pages/dashboard/pages/overview/components/UserCompositionCo';
import OverviewMetricsTrendCo from '@/pages/dashboard/pages/overview/components/OverviewMetricsTrendCo';
import PlatformMetricsCo from '@/pages/dashboard/pages/overview/components/PlatformMetricsCo';
import KeyMetricsCo from '@/pages/dashboard/pages/overview/components/KeyMetricsCo';
import MetricsRankListCo from '@/pages/dashboard/pages/overview/components/MetricsRankListCo';
import MetricsUserCompositionCo from '@/pages/dashboard/pages/overview/components/MetricsUserCompositionCo';
import OverviewTableCo from '@/pages/dashboard/pages/overview/components/OverviewTableCo';
import PcConsoleWeeklyFilter from '@/pages/dashboard/filterPageComponents/overview/PcConsoleWeeklyFilter';
import PcConsoleMonthlyFilter from '@/pages/dashboard/filterPageComponents/overview/PcConsoleMonthlyFilter';
import RankListTabCo from '@/pages/dashboard/pages/overview/components/RankListTabCo';
import EventService from '@/pages/dashboard/pages/overview/components/OverviewMetricsTrendCo/EventService';
import KpiOverviewEventDataBridge from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiOverviewEventDataBridge';
import AnomalyService from '@/pages/dashboard/pages/overview/kpiOverview/components/AnomalyService';
import KpiEventMetricTrendService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiEventMetricTrendService';
import KpiEventDimensionTrendService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiEventDimensionTrendService';
import KpiNaturalNewRankService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiNaturalNewRankService';
import KpiOverallPerformanceDimensionTrendService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiOverallPerformanceDimensionTrendService';
import KpiApplovinRegionTrendService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiApplovinRegionTrendService';
import KpiEventAllPlatformTabTrendService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiEventAllPlatformTabTrendService';
import PcConsoleDailyFilter from '@/pages/dashboard/filterPageComponents/overview/pcConsoleDailyFilter';
import NightingaleDailyFilter from '@/pages/dashboard/filterPageComponents/overview/nightingaleDailyFilter';
import NightingaleDailyFilterV2 from '@/pages/dashboard/filterPageComponents/overview/nightingaleDailyFilterV2';
import NightingaleRankListCo from '@/pages/dashboard/pages/overview/nightingaleDaily/componnents/NightingaleRankListCo';
import MetricsSegementCo from '@/pages/dashboard/components/MetricsTrendCo/MetricsSegementCo';
import MetricsTrendCo from '@/pages/dashboard/components/MetricsTrendCo';
import NightingaleDataRangeFilter from '@/pages/dashboard/filterPageComponents/overview/nightingaleDataRangeFilter';
import NightingaleKeyMetricsService from '@/pages/dashboard/pages/overview/components/KeyMetricsCo/nightingaleKeyMetricsService';
import DataRangeTrendCo from '@/pages/dashboard/components/MetricsTrendCo/DataRangeTrendCo';
import DailyXhFilterCo from '@/pages/dashboard/filterPageComponents/overview/dailyXhFilterCo';
import MonthlyXhFilterCo from '@/pages/dashboard/filterPageComponents/overview/monthlyXhFilterCo';
import CommonMobileDailyRankListCo from '@/pages/dashboard/components/CommonMobileDailyRankListCo';
import CommonMobileDailyRankServiceCo from '@/pages/dashboard/components/CommonMobileDailyRankServiceCo';
import MobileKeyMetricsCo from '@/pages/dashboard/pages/overview/components/KeyMetricsCo/mobileKeyMetricsCo';
import MobileDaily from '@/pages/dashboard/pages/overview/components/MobileDaily';
import MetricsCardWrap from '@/pages/dashboard/components/MetricsCardWrap';
import MetricsCardRank from '@/pages/dashboard/components/MetricsCardRank';
import MobileWeekly from '@/pages/dashboard/pages/overview/components/MobileWeekly';
import MobileMonthly from '@/pages/dashboard/pages/overview/components/MobileMonthly';
import LifetimeFIlter from '@/pages/dashboard/filterPageComponents/overview/lifetimeFIlter';
import LifetimeSalesBreakDownService from '@/pages/dashboard/pages/overview/components/LifetimeSalesBreakDownService';
import LifetimeCardContainer from '@/pages/dashboard/pages/overview/lifetime/components/LifetimeCardContainer';
import IngameDlpTopChartContextTransfer from '@/pages/dashboard/pages/overview/lifetime/components/IngameDlpTopChartContextTransfer';
import LifetimeSalesBreakDownServiceTransfer from '@/pages/dashboard/pages/overview/lifetime/components/LifetimeSalesBreakDownServiceTransfer';
import ForecastCardWrap from '@/pages/dashboard/pages/forecast/components/ForecastCardWrap';
import ForecastMetricCard from '@/pages/dashboard/pages/forecast/components/ForecastMetricCard';
import ForecastService from '@/pages/dashboard/pages/forecast/forecastService';
import UnitSalesBarChart from '@/pages/dashboard/pages/forecast/components/UnitSalesBarChart';
import MarkAreaTrend from '@/pages/dashboard/pages/forecast/components/MarkAreaTrend';
import SectionHeadingWithSub from '@/pages/dashboard/components/SectionHeadingWithSub';
import RankProgressListCard from '@/pages/dashboard/components/RankProgressListCard';
import KpiSummaryCard from '@/pages/dashboard/components/KpiSummaryCard';
import KpiProgressDetailCard from '@/pages/dashboard/components/KpiProgressDetailCard';
import UaTeamMetricsCards from '@/pages/dashboard/pages/overview/kpiOverview/components/UaTeamMetricsCards';
import AiAnalysisGuard from '@/pages/dashboard/pages/overview/kpiOverview/components/AiAnalysisGuard';
import KpiAiSummaryService from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiAiSummaryService';
import KpiFilterGuard from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiFilterGuard';
import kpiOverViewFIlter from '@/pages/dashboard/filterPageComponents/overview/kpiOverViewFIlter';
import KpiOverviewScopeTabs from '@/pages/dashboard/pages/overview/kpiOverview/components/KpiOverviewScope';
import ScopeAwareCommonCol from '@/pages/dashboard/components/ScopeAwareCommonCol';

export default {
  PcConsoleDailyFilterV2,
  PcConsoleDailyFilterV3,
  DauBreakdownContext,
  OsBreakDownContext,
  CountriesContextTab,
  DauCountriesContext,
  NewCountriesContext,
  PcConsoleOverviewV2Table,
  UserCompositionCo,
  OverviewMetricsTrendCo,
  PlatformMetricsCo,
  KeyMetricsCo,
  MetricsRankListCo,
  MetricsUserCompositionCo,
  OverviewTableCo,
  PcConsoleWeeklyFilter,
  PcConsoleMonthlyFilter,
  RankListTabCo,
  EventService,
  KpiOverviewEventDataBridge,
  AnomalyService,
  KpiEventMetricTrendService,
  KpiEventDimensionTrendService,
  KpiOverallPerformanceDimensionTrendService,
  KpiApplovinRegionTrendService,
  KpiEventAllPlatformTabTrendService,
  PcConsoleDailyFilter,
  NightingaleDailyFilter,
  NightingaleDailyFilterV2,
  NightingaleRankListCo,
  MetricsSegementCo,
  MetricsTrendCo,
  NightingaleDataRangeFilter,
  NightingaleKeyMetricsService,
  DataRangeTrendCo,
  // 去小号 daily
  DailyXhFilterCo,
  CommonMobileDailyRankListCo,
  CommonMobileDailyRankServiceCo,
  MobileKeyMetricsCo,
  // 去小号 Monthly
  MonthlyXhFilterCo,
  MobileDaily,
  MetricsCardWrap,
  MetricsCardRank,
  MobileWeekly,
  MobileMonthly,
  LifetimeFIlter,
  LifetimeSalesBreakDownService,
  LifetimeCardContainer,
  IngameDlpTopChartContextTransfer,
  LifetimeSalesBreakDownServiceTransfer,
  // Forecast
  ForecastCardWrap,
  ForecastMetricCard,
  ForecastService,
  UnitSalesBarChart,
  MarkAreaTrend,
  SectionHeadingWithSub,
  RankProgressListCard,
  KpiNaturalNewRankService,
  KpiSummaryCard,
  KpiProgressDetailCard,
  UaTeamMetricsCards,
  AiAnalysisGuard,
  KpiAiSummaryService,
  KpiFilterGuard,
  kpiOverViewFIlter,
  KpiOverviewScopeTabs,
  ScopeAwareCommonCol
};